// extracted by mini-css-extract-plugin
module.exports = {"moreOptionsMenu":"styles_moreOptionsMenu__q7kW2","undoButton":"styles_undoButton__dlNdA","deleteModeOn":"styles_deleteModeOn__yG4Fg"};